import { catalogApi } from "./config";

const synchronizeCatalog = async ({ categoryString, store, username }) => {
  try {
    const url = `/api/v1/VtexCataogue/actualizarProductos?${categoryString}`;
    const response = await catalogApi.post(url, null, {
      params: {
        store,
        username,
      },
    });
    return response;
  } catch (error) {
    throw new Error(`No se ha podido sincronizar catalogo ${store}`);
  }
};

const synchronizeCatalogAll = async ({ categoryString, store, username }) => {
  try {
    const url = `/api/v1/sync/all?${categoryString}`;
    const response = await catalogApi.post(url, null, {
      params: {
        store,
        username,
      },
    });
    return response;
  } catch (error) {
    throw new Error(`No se ha podido sincronizar catalogo ${store}`);
  }
};

const syncCollectionById = async ({ idCollection, store, username }) => {
  try {
    // api/v1/Collection/sync-by-id
    const url = `/api/v1/Collection/sync-by-id?store=${store}&username=${username}&idCollection=${idCollection}`;
    // const url = `/api/v1/Collection/sync-by-id?idCollection=${idCollection}&store=${store}&username=${username}`;
    const response = await catalogApi.get(url);
    return response;
  } catch (error) {
    throw new Error(`No se ha podido sincronizar la colección ${store}`);
  }
};

/**
 * POST sync-vtex catalogue products by VTEX product ids.
 * ASSUMPTION: Backend base path is under REACT_APP_API_CATALOGUE (catalogApi).
 *
 * @param {Object} params
 * @param {string} params.username
 * @param {string} params.store
 * @param {string[]} params.productIds
 * @param {boolean} [params.syncInventory=false]
 * @returns {Promise<import('axios').AxiosResponse<string>>} response.data is typically "OK"
 */
/**
 * Normalizes sync-by-ids API payload (legacy "OK" string or structured result).
 */
const normalizeSyncByIdsResult = (responseData) => {
  if (responseData === "OK") {
    return { synced: [], skippedInactive: [], failed: [], legacy: true };
  }
  const body =
    responseData?.data ??
    responseData?.Data ??
    responseData ??
    {};
  const failedRaw = body.failed ?? body.Failed ?? [];
  const failed = failedRaw.map((item) =>
    typeof item === "object"
      ? {
          productId: item.productId ?? item.ProductId,
          reason: item.reason ?? item.Reason ?? "unknown",
        }
      : { productId: item, reason: "unknown" }
  );
  return {
    synced: body.synced ?? body.Synced ?? [],
    skippedInactive: body.skippedInactive ?? body.SkippedInactive ?? [],
    failed,
    legacy: false,
  };
};

/**
 * Navbar notification text after syncing missing collection products.
 * Example: "Sync no visibles: OK 3 elemento(s), error procesando IDs [30996, 72129]"
 */
const formatSyncMissingProductsNotification = (syncResult) => {
  if (!syncResult) {
    return "Sync no visibles: sin respuesta del servidor";
  }
  if (syncResult.legacy) {
    return "Sync no visibles: OK";
  }

  const synced = syncResult.synced ?? [];
  const failed = syncResult.failed ?? [];
  const failedIds = failed
    .map((item) => item?.productId)
    .filter((id) => id !== undefined && id !== null);

  const parts = ["Sync no visibles:"];
  if (synced.length > 0) {
    parts.push(`OK ${synced.length} elemento(s)`);
  }
  if (failedIds.length > 0) {
    parts.push(`error procesando IDs [${failedIds.join(", ")}]`);
  }
  if (synced.length === 0 && failedIds.length === 0) {
    parts.push("sin productos sincronizados");
  }

  return parts.join(" ");
};

const syncCatalogueProductsByIds = async ({
  username,
  store,
  productIds,
  syncInventory = false,
}) => {
  try {
    const url = `/api/v1/sync-vtex/catalogue-products-by-ids`;
    const response = await catalogApi.post(url, productIds, {
      params: {
        username,
        store,
        syncInventory,
      },
    });
    return {
      ...response,
      syncResult: normalizeSyncByIdsResult(response.data),
    };
  } catch (error) {
    throw new Error(
      `No se ha podido sincronizar productos del catálogo (${store})`
    );
  }
};

export {
  synchronizeCatalog,
  synchronizeCatalogAll,
  syncCatalogueProductsByIds,
  normalizeSyncByIdsResult,
  formatSyncMissingProductsNotification,
  syncCollectionById,
};
